export const HOME = '/'
export const HOME2 = '/home'
export const WHATWEDO = '/whatwedo'
export const SERVICES = '/services'
export const TRADING = '/trading'
export const ABOUT = '/about'
export const PORTFOLIO = '/portfolio'
export const TESTIMONIALS = '/testimonials'
export const ADVISORY = '/advisory'
